//
// Theme responsive navbar
//

(function ($, waTheme) {

    var NavbarResponsive = (function ($) {

        NavbarResponsive = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$wrapper_outer = that.$wrapper.parents(".b-nav-responsive-outer");
            that.$nav_items = that.$wrapper.find(".nav-item");
            that.$nav_more = that.$wrapper.find(".nav-item-more");
            that.$nav_more_droprown = that.$nav_more.find(".nav-item-more__dropdown-menu");

            // VARS
            that.hidden_class = "is-hidden";
            that.nav_width = that.$wrapper[0].getBoundingClientRect().width;
            that.nav_more_width = that.$nav_more[0] !== undefined ? that.$nav_more[0].getBoundingClientRect().width : 0;

            // DYNAMIC VARS
            that.container_width = that.$wrapper_outer[0].getBoundingClientRect().width;
            // that.resizeEvent = true;
            // that.nav_items_width = 0;
            // that.hide_items = false;

            // фолбек если меню пустое
            if (that.$nav_items.length) {
                // INIT
                that.init();

                // EVENTS
                that.bindEvents();
            } else {
                that.$wrapper_outer.addClass("is-loaded");
            }
        };

        NavbarResponsive.prototype.init = function () {
            var that = this,
                row_gap = parseInt(that.$wrapper_outer.css("gap")),
                nav_gap = parseInt(that.$wrapper.children().css("gap")),
                width = 0;

            // that.container_width += that.$wrapper_outer.children().length * nav_gap;

            that.$wrapper.children(".navbar-nav").removeClass("justify-content-between");
            that.$nav_items.removeClass(that.hidden_class);
            that.$nav_more.removeClass("is-hidden");
            that.$nav_more_droprown.children().addClass("is-hidden");

            $.each(that.$wrapper_outer.children(), function () {
                // console.log($(this)[0].getBoundingClientRect().width)
                // console.log($(this)[0].getBoundingClientRect().width);
                // width += $(this)[0].getBoundingClientRect().width;
                width += $(this)[0].getBoundingClientRect().width;
            });

            if (!isNaN(row_gap)) {
                width += (that.$wrapper_outer.children().length - 1) * row_gap;
            }

            // console.log({
            //     container_width: that.container_width,
            //     container_items_width: width,
            //     gap: (that.$wrapper_outer.children().length - 1) * row_gap,
            // });

            if (width > that.container_width) {
                $.each(that.$nav_items.get().reverse(), function (index) {
                    if (width > that.container_width && index > 0) {
                        width = width - $(this)[0].getBoundingClientRect().width - nav_gap;

                        var item_id = $(this).data("item-id");
                        that.$nav_more_droprown.find(`[data-item-id="${item_id}"]`).removeClass("is-hidden");

                        // console.log({
                        //     nav_gap: nav_gap,
                        //     container_items_width: width,
                        //     item_width: $(this)[0].getBoundingClientRect().width
                        // });

                        // Скрываем элемент
                        $(this).addClass(that.hidden_class);
                    }
                });
                if (that.$wrapper_outer.children().length === 1) {
                    that.$wrapper.children(".navbar-nav").addClass("justify-content-between");
                }
            } else {
                that.$nav_more.addClass("is-hidden");
            }

            new window.waTheme.init.site.Dropdown();

            that.$wrapper_outer.addClass("is-loaded");
        };

        NavbarResponsive.prototype.bindEvents = function () {
            var that = this;

            // if (that.resizeEvent === true) {0
                $(window).on("resize", function () {
                    if (that.container_width !== that.$wrapper_outer[0].getBoundingClientRect().width) {
                        // Обновляем ширину контейнра
                        that.container_width = that.$wrapper_outer[0].getBoundingClientRect().width;
                        // Обновляем меню
                        that.init();
                    }
                });
            // }
        };

        return NavbarResponsive;

    })($);

    waTheme.init.site.NavbarResponsive = NavbarResponsive;

    var $wrapper = $(".b-nav-responsive");
    if ($wrapper.length) {
        $wrapper.each(function () {
            waTheme.apps["site"].NavbarResponsive = new window.waTheme.init.site.NavbarResponsive({
                $wrapper: $(this),
            });
        });
    }

})(jQuery, window.waTheme);
